import { render, staticRenderFns } from "./ClampedText.vue?vue&type=template&id=9cc38e56&scoped=true"
import script from "./ClampedText.vue?vue&type=script&lang=js"
export * from "./ClampedText.vue?vue&type=script&lang=js"
import style0 from "./ClampedText.vue?vue&type=style&index=0&id=9cc38e56&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc38e56",
  null
  
)

export default component.exports